import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export function advaniaServicesRoutes(childrenRoutes: Routes = []): Routes {
    return [
        {
            path: advaniaServicesSegments.advaniaServices,
            children: [
                {
                    path: '',
                    pathMatch: 'full',
                    loadComponent: () =>
                        import('./features/get-services/get-services-page/get-services.page').then(
                            (m) => m.GetServicesPage,
                        ),
                },
                ...childrenRoutes,
                {
                    path: ':serviceId',
                    loadComponent: () =>
                        import('./features/get-service/get-service-page/get-service.page').then(
                            (m) => m.GetServicePage,
                        ),
                },
            ],
        },
    ];
}
